const actions = {
  send({ commit }, payload) {
    console.log(payload);
  },
};

export default {
  namespaced: true,
  actions,
};
